const fonts = {
  size: {
    extra: '64px',
    largest: '24px',
    larger: '20px',
    large: '18px',
    medium: '16px',
    small: '14px',
    smallest: '12px',
    tiny: '10px',
  },
  weight: {
    bold: 700,
    medium: 500,
    regular: 400,
    light: 300,
  },
};

export { fonts };
